<script lang="ts">
  export let label: string;
</script>

<div class="mb-0">
  <p class="label">{label}:</p>
  <p class="value ms-1">
    <slot></slot>
  </p>
</div>

<style>
  .label {
    display: inline;
    font-size: 15px;
  }

  .value {
    display: inline;
    font-size: 15px;
    font-weight: 500;
  }

  @media (min-width: 991px) and (max-width: 1200px) {
    .label {
      font-size: 15px;
    }

    .value {
      font-size: 15px;
    }
  }

  @media (max-width: 767px) {
    .label {
      font-size: 15px;
    }

    .value {
      font-size: 15px;
    }
  }
</style>
